import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "./dialog";
import { Button } from "./button";
import { cn } from "../../lib/utils";

const ConfirmDialog = React.forwardRef(
  (
    {
      className,
      open,
      onOpenChange,
      onConfirm,
      onCancel,
      title = "Are you sure?",
      description,
      confirmText = "Confirm",
      cancelText = "Cancel",
      variant = "default",
      loading = false,
      showCloseButton = true,
      ...props
    },
    ref
  ) => {
    const handleCancel = () => {
      if (loading) return;
      onCancel?.();
      onOpenChange?.(false);
    };

    const handleOpenChange = (nextOpen) => {
      if (!nextOpen) {
        handleCancel();
      } else {
        onOpenChange?.(true);
      }
    };

    const handleConfirm = () => {
      onConfirm?.();
    };

    return (
      <Dialog open={open} onOpenChange={handleOpenChange}>
        <DialogContent
          ref={ref}
          className={cn("max-w-md", className)}
          showCloseButton={showCloseButton && !loading}
          {...(!description && { 'aria-describedby': undefined })}
          {...props}
        >
          <DialogHeader className={showCloseButton && !loading ? "pr-8" : undefined}>
            <DialogTitle>{title}</DialogTitle>
            {description && (
              <DialogDescription>{description}</DialogDescription>
            )}
          </DialogHeader>
          <DialogFooter className="gap-2 sm:gap-0">
            <Button
              variant="ghost"
              className="min-h-11"
              onClick={handleCancel}
              disabled={loading}
            >
              {cancelText}
            </Button>
            <Button
              variant={variant === "destructive" ? "destructive" : "default"}
              className="min-h-11"
              onClick={handleConfirm}
              disabled={loading}
            >
              {loading ? "..." : confirmText}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
);
ConfirmDialog.displayName = "ConfirmDialog";

export { ConfirmDialog };
